import React from 'react';
import { Form, Input, Button, Row, Col } from 'antd';

const DynamicField = ({ index, value, label, onValueChange, onLabelChange, onRemove, isReadOnly }) => {
  return (
    <Form.Item key={`dynamic_${index}`} className="mb-6">
      <Row gutter={8}>
        <Col span={6}>
          <Input
            value={label}
            onChange={(e) => onLabelChange(index, e.target.value)}
            readOnly={isReadOnly}
            placeholder={`Label for field ${index + 1}`}
          />
        </Col>
        <Col span={12}>
          <Input
            value={value}
            onChange={(e) => onValueChange(index, e.target.value)}
            readOnly={isReadOnly}
            placeholder={`Value for field ${index + 1}`}
          />
        </Col>
        <Col span={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="link"
            onClick={() => onRemove(index)}
            disabled={isReadOnly}
            style={{ color: 'red' }}
          >
            Remove
          </Button>
        </Col>
      </Row>
    </Form.Item>
  );
};

export default DynamicField;